import uniq from 'lodash/uniq'

import { useAppState } from './useAppState'

export function useNotificationsCount() {
  const appState = useAppState()

  const relationships = uniqueCount(
    ...appState.panelRequestedNew,
    ...appState.panelRequestedUpdated,
    ...appState.panelApprovedNew,
    ...appState.panelApprovedUpdated,
  )

  const networkApprovalRequests = uniqueCount(...appState.panelRequestPending)
  const referralApprovalRequests = uniqueCount(
    ...appState.referralApprovalRequestNew,
  )

  const approvalRequests = networkApprovalRequests + referralApprovalRequests

  const referrals = uniqueCount(
    ...appState.referralFromNew,
    ...appState.referralFromUpdated,
    ...appState.referralToNew,
    ...appState.referralToUpdated,
  )

  return {
    professionalNetwork: relationships + approvalRequests,
    relationships,
    networkApprovalRequests,
    referralApprovalRequests,
    approvalRequests,
    referrals,
  }
}

function uniqueCount(...nums: number[]): number {
  return uniq(nums).length
}
